"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _LFCCard = _interopRequireDefault(require("./LFCCard.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LFCCardContainer = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__LFCCardContainer",
  componentId: "sc-1h6zbta-0"
})(["display:flex;flex-direction:column;width:auto;text-align:center;align-items:center;gap:", ";border:1px solid ", ";background:", ";padding:", ";border-bottom:", ";&:hover{cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.mini;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
}, function (_ref3) {
  var theme = _ref3.theme,
      isActive = _ref3.isActive;
  return isActive ? theme.backgroundColor.secondaryLight : theme.backgroundColor.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.none, " ").concat(theme.space.xxtiny);
}, function (_ref5) {
  var theme = _ref5.theme,
      isActive = _ref5.isActive;
  return isActive && "".concat(theme.space.mini, " solid ").concat(theme.colors.secondary);
});

var DateContainer = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__DateContainer",
  componentId: "sc-1h6zbta-1"
})(["font-size:", ";color:", ";font-family:", ";line-height:150%;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.XSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyDark;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily.default;
});

var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__PriceWrapper",
  componentId: "sc-1h6zbta-2"
})(["display:flex;flex-direction:row;justify-content:center;"]);

var PriceContainer = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__PriceContainer",
  componentId: "sc-1h6zbta-3"
})(["font-size:", ";color:", ";font-family:", ";line-height:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize.small;
}, function (_ref10) {
  var theme = _ref10.theme,
      isLeast = _ref10.isLeast;
  return isLeast ? theme.colors.tertiary : theme.colors.neutral;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.semiLarge;
});

var ShimmerDateContainer = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__ShimmerDateContainer",
  componentId: "sc-1h6zbta-4"
})(["max-width:", ";width:100%;padding-top:", ";"], function (_ref13) {
  var theme = _ref13.theme,
      isMobile = _ref13.isMobile;
  return isMobile ? theme.space.semiLarge : theme.space.large;
}, function (_ref14) {
  var theme = _ref14.theme,
      isMobile = _ref14.isMobile;
  return isMobile ? theme.space.xxtiny : theme.space.tiny;
});

var ShimmerPriceContainer = _styledComponents.default.div.withConfig({
  displayName: "LFCCard__ShimmerPriceContainer",
  componentId: "sc-1h6zbta-5"
})(["max-width:", ";width:100%;padding-top:", ";padding-bottom:", ";"], function (_ref15) {
  var theme = _ref15.theme,
      isMobile = _ref15.isMobile;
  return isMobile ? theme.space.large : theme.space.XLarge;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.xxtiny;
}, function (_ref17) {
  var theme = _ref17.theme,
      isMobile = _ref17.isMobile;
  return isMobile ? theme.space.tiny : theme.space.micro;
});

var LFCCard = function LFCCard(props) {
  var date = props.date,
      formattedDate = props.formattedDate,
      price = props.price,
      active = props.active,
      least = props.least,
      theme = props.theme,
      handleClick = props.handleClick,
      currency = props.currency,
      showShimmer = props.showShimmer,
      customProperties = props.customProperties,
      isMobile = props.isMobile;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var clickApplyHandler = function clickApplyHandler() {
    if (handleClick) handleClick(date);
  };

  var getPrice = function getPrice() {
    return /*#__PURE__*/_react.default.createElement(PriceWrapper, null, price ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PriceContainer, {
      isLeast: least
    }, currency), "\xA0", /*#__PURE__*/_react.default.createElement(PriceContainer, {
      isLeast: least
    }, price)) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "RemoveIcon",
      fontsize: "small",
      accessible: false
    }));
  };

  var getShimmer = function getShimmer() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedDate ? /*#__PURE__*/_react.default.createElement(DateContainer, null, formattedDate) : /*#__PURE__*/_react.default.createElement(ShimmerDateContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, {
      borderRadius: _constant.SHIMMER_DIMENTIONS,
      theme: theme,
      height: _constant.SHIMMER_DIMENTIONS,
      colorAnimation: true
    })), /*#__PURE__*/_react.default.createElement(ShimmerPriceContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, {
      borderRadius: _constant.SHIMMER_DIMENTIONS,
      height: _constant.SHIMMER_DIMENTIONS,
      theme: theme,
      colorAnimation: true
    })));
  };

  var getDateContainer = function getDateContainer() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DateContainer, null, formattedDate), /*#__PURE__*/_react.default.createElement(PriceWrapper, null, getPrice()));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(LFCCardContainer, (0, _extends2.default)({
      isActive: active,
      onClick: clickApplyHandler
    }, customProperties, {
      price: price
    }), showShimmer ? getShimmer() : getDateContainer());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

LFCCard.propTypes = _LFCCard.default.PropTypes;
LFCCard.defaultProps = _LFCCard.default.DefaultProps;
var _default = LFCCard;
exports.default = _default;